import React from 'react'
import prefectPreDateBanner from "./../../../../../Images/Blog/PerfectPreDate/Banner.png"

const PerfectPreDateImg = () => {
  return (
    <div className="pediManicureImg">
      <img src={prefectPreDateBanner} alt="prefectPreDateBanner" loading='lazy'/>
    </div>
  )
}

export default PerfectPreDateImg
